<template>
  <div class="input-type-selector">
    <div class="row control-row">
      <el-select
        v-if="!isOnlyOne"
        v-model="currentSelectType"
        placeholder="请选择"
        :style="{ width: typeWidth + 'px' }"
        class="type-select"
        @change="changeType"
      >
        <el-option
          v-for="item in selectOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <div v-else class="left-name">
        {{ selectOptions[0]?.label || "" }}
      </div>

      <div class="flex-1 self-input">
        <el-input
          v-bind="$attrs"
          v-model.trim="inputVal"
          @input="valInput"
          @focus="elFocus"
          @blur="elBlur"
          @keyup.enter="search"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputTypeSelector",
  inheritAttrs: false,
  props: {
    self: {
      type: [Object, String, Number],
      required: true,
    },
    modelval: {
      type: String,
      default: "",
    },
    selectType: {
      type: String,
      default: "",
    },
    selectOptions: {
      type: Array,
      default: () => [],
    },
    typeWidth: {
      type: Number,
      default: 150,
    },
  },
  data() {
    return {
      inputVal: "",
      currentSelectType: this.selectType,
    };
  },
  computed: {
    isOnlyOne() {
      return this.selectOptions.length === 1;
    },
  },
  watch: {
    self: {
      handler() {
        this.format();
      },
      deep: true,
    },
    modelval() {
      this.format();
    },
    selectType(value) {
      this.currentSelectType = value;
    },
  },
  mounted() {
    this.format();
    if (!this.currentSelectType && this.selectOptions.length > 0) {
      this.currentSelectType = this.selectOptions[0].value;
    }
  },
  methods: {
    format() {
      if (this.modelval === "") {
        this.inputVal = this.self ?? "";
        return;
      }
      this.inputVal = this.self?.[this.modelval] ?? "";
    },
    changeType(value) {
      this.$emit("changeType", value);
    },
    valInput(value) {
      if (this.modelval !== "" && this.self && typeof this.self === "object") {
        this.self[this.modelval] = value;
      }
      this.$emit("input", value);
    },
    elFocus(event) {
      this.$emit("focus", event);
    },
    elBlur() {
      if (this.modelval !== "" && this.self && typeof this.self === "object") {
        this.self[this.modelval] = this.inputVal;
      }
      this.$emit("blur", this.inputVal);
    },
    search() {
      this.$emit("keyUpSearch");
    },
  },
};
</script>

<style scoped lang="scss">
.input-type-selector {
  .control-row {
    align-items: stretch;
    min-height: 32px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    overflow: hidden;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    :deep(.el-select__wrapper) {
      box-shadow: none !important;
      padding-right: 0px;
    }

    &:focus-within {
      border-color: var(--el-color-primary);
      box-shadow: 0 0 0 1px
        color-mix(in srgb, var(--el-color-primary) 22%, white) inset;
    }
  }

  .left-name {
    display: flex;
    align-items: center;
    font-size: 13px;
    padding: 0 20px 0 14px;
    white-space: nowrap;
    background: #fff;
  }

  .self-input {
    display: flex;
    align-items: center;
    font-size: 13px;
    min-width: 0;
  }

  :deep(.type-select) {
    flex-shrink: 0;
  }

  :deep(.type-select .el-input__wrapper) {
    border-radius: 0;
    box-shadow: none !important;
    background: transparent;
    min-height: 30px;
  }

  :deep(.type-select .el-input.is-focus .el-input__wrapper) {
    box-shadow: none !important;
  }

  :deep(.type-select .el-input__inner) {
    font-size: 13px;
  }

  :deep(.type-select .el-select__caret) {
    color: #b8bec8;
  }

  :deep(.self-input .el-input) {
    width: 100%;
  }

  :deep(.self-input .el-input__wrapper) {
    border-radius: 0;
    box-shadow: none !important;
    background: transparent;
    min-height: 32px;
    padding-left: 12px;
    padding-right: 12px;
  }

  :deep(.self-input .el-input.is-focus .el-input__wrapper) {
    box-shadow: none !important;
  }

  :deep(.self-input .el-input__inner) {
    font-size: 13px;
  }

  :deep(.el-select:hover .el-input__wrapper),
  :deep(.self-input .el-input:hover .el-input__wrapper) {
    box-shadow: none !important;
  }
}
</style>
